import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 3.3335V12.6668",
		stroke: "#50566E",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.3335 8H12.6668",
		stroke: "#50566E",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPlus;
